import { HttpInterceptorFn } from "@angular/common/http";

const SAFE_METHODS = new Set(["GET", "HEAD", "OPTIONS"]);

export const csrfInterceptor: HttpInterceptorFn = (req, next) => {
  if (SAFE_METHODS.has(req.method.toUpperCase())) {
    return next(req);
  }

  const csrfToken = getCookie("XSRF-TOKEN");
  if (csrfToken && !req.headers.has("X-CSRF-Token")) {
    const csrfReq = req.clone({
      setHeaders: { "X-CSRF-Token": csrfToken },
    });
    return next(csrfReq);
  }

  return next(req);
};

function getCookie(name: string): string | null {
  const prefix = `${name}=`;
  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const trimmed = cookie.trim();
    if (trimmed.startsWith(prefix)) {
      return decodeURIComponent(trimmed.substring(prefix.length));
    }
  }
  return null;
}
